/**
 * Alle Oberflächentexte zentral. Für eine spätere Übersetzung wird hier
 * ein weiteres Wörterbuch mit denselben Schlüsseln ergänzt.
 */
const de = {
  'app.name': 'Kartothek',
  'app.outdated': 'Kartothek wurde aktualisiert. Bitte neu laden – bis dahin wird nichts gespeichert.',
  'app.reload': 'Jetzt neu laden',
  'common.save': 'Speichern',
  'common.saving': 'Speichert …',
  'common.saved': 'Gespeichert',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.create': 'Anlegen',
  'common.edit': 'Bearbeiten',
  'common.read': 'Lesen',
  'common.loading': 'Lädt …',
  'common.error': 'Fehler',
  'common.close': 'Schließen',
  'common.name': 'Name',
  'common.password': 'Passwort',
  'common.back': 'Zurück',
  'common.rename': 'Umbenennen',
  'common.none': '—',

  'offline.offline': 'Offline',
  'offline.savedLocal': 'Lokal gespeichert',
  'offline.pending': '{n} Änderung(en) warten',
  'offline.sending': 'Sende {n} Änderung(en) …',
  'offline.problems': '{n} Sync-Problem(e)',
  'offline.notCached': 'Offline – das ist nicht in der lokalen Kopie.',
  'offline.unsupported': 'Offline – das geht erst wieder mit Verbindung.',
  'offline.renameOffline': 'Offline – Umbenennen, Verschieben und Typwechsel gehen erst wieder mit Verbindung.',
  'offline.serverError': 'Der Server konnte die Änderung nicht verarbeiten.',
  'offline.conflict': 'Die Notiz wurde auf einem anderen Gerät geändert, während du offline warst. Deine Fassung ist unten aufgehoben.',
  'offline.labelNote': 'Notiz „{title}“',
  'offline.labelCombat': 'Kampf „{name}“',
  'offline.labelMap': 'Karte',
  'offline.labelOther': 'Änderung',
  'offline.problemsTitle': 'Sync-Probleme',
  'offline.problemsEmpty': 'Keine offenen Probleme.',
  'offline.useMine': 'Meine Fassung übernehmen',
  'offline.discard': 'Verwerfen',
  'offline.openNote': 'Notiz öffnen',
  'offline.dismiss': 'OK',
  'offline.statusTitle': 'Offline & Synchronisierung',
  'offline.statusIntro': 'Kartothek hält eine lokale Kopie dieser Kampagne auf diesem Gerät. Bricht die Verbindung ab (WLAN, VPN), kannst du weiterlesen und Notizen, Session-Log, Karten und Kampf weiter bearbeiten – die Änderungen werden gesendet, sobald der Server wieder erreichbar ist.',
  'offline.lastSync': 'Zuletzt abgeglichen',
  'offline.never': 'noch nie',
  'offline.copy': 'Lokal: {notes} Notizen, {maps} Karten, {combats} Kämpfe, {files} Bilder',
  'offline.syncNow': 'Jetzt abgleichen',
  'offline.reload': 'Lokale Kopie neu laden',
  'offline.logoutPending': 'Es gibt noch {n} ungesendete Änderung(en). Beim Abmelden gehen sie verloren. Trotzdem abmelden?',
  'offline.install': 'Als App installieren',
  'offline.installHint': 'Im Browser-Menü „App installieren“ wählen (Edge/Chrome) bzw. „Zum Home-Bildschirm“ (Safari). Offline starten lässt sich die App nur über HTTPS oder localhost.',

  'auth.login': 'Anmelden',
  'auth.logout': 'Abmelden',
  'auth.setupTitle': 'Ersteinrichtung',
  'auth.setupIntro': 'Lege den DM-Account an. Er erhält Admin-Rechte.',
  'auth.setupSubmit': 'Account anlegen',
  'auth.passwordHint': 'Mindestens 10 Zeichen',
  'auth.account': 'Konto',

  'role.dm': 'DM',
  'role.co-dm': 'Co-DM',
  'role.player': 'Spieler',

  'invite.title': 'Einladung',
  'invite.intro': 'Du wurdest in die Kampagne „{name}“ eingeladen (Rolle: {role}).',
  'invite.invalid': 'Diese Einladung ist ungültig oder abgelaufen. Bitte den DM um einen neuen Link.',
  'invite.join': 'Beitreten',
  'invite.joinAs': 'Als {name} beitreten',
  'invite.already': 'Du bist bereits Mitglied dieser Kampagne.',
  'invite.open': 'Zur Kampagne',
  'invite.register': 'Neues Konto anlegen',
  'invite.haveAccount': 'Ich habe schon ein Konto',
  'invite.newAccount': 'Ich brauche ein neues Konto',
  'invite.loginFirst': 'Melde dich an, danach trittst du der Kampagne bei.',
  'invite.switchUser': 'Mit anderem Konto beitreten (abmelden)',

  'player.screen': 'Spieleransicht (Karte)',
  'note.playerNoteHint': 'Deine Notizen liegen im Ordner „Spieler/<Name>“. Zuerst siehst nur du (und der DM) sie – teilen kannst du sie im Editor.',
  'reveal.owner': 'Gehört (darf bearbeiten)',
  'reveal.noOwner': 'niemandem',
  'player.discoveries': 'Entdeckt',
  'player.new': 'neu',
  'player.allSeen': 'Alle als gesehen markieren',
  'reveal.title': 'Freigeben',
  'reveal.toAll': 'Allen Spielern',
  'reveal.some': '{n} Spieler',
  'reveal.seen': 'gesehen {date}',
  'reveal.unseen': 'neu – noch nicht geöffnet',
  'reveal.noPlayers': 'Noch keine Spieler in der Kampagne (Einladungslinks unter Einstellungen).',
  'reveal.hint': 'Spieler sehen die Notiz ohne %% Kommentare %% und :::dm-Blöcke.',
  'player.welcome': 'Willkommen! Hier erscheint, was der DM für dich freigibt.',
  'player.nothing': 'Noch nichts freigegeben.',
  'player.recent': 'Zuletzt aktualisiert',
  'members.title': 'Mitglieder',
  'members.intro': 'Spieler sehen nur Notizen, die für alle oder für sie freigegeben sind – ohne %% Kommentare %% und :::dm-Blöcke. Co-DMs sehen und bearbeiten alles, verwalten aber keine Mitglieder.',
  'members.role': 'Rolle',
  'members.remove': 'Entfernen',
  'members.removeConfirm': '{name} aus der Kampagne entfernen?',
  'members.leave': 'Kampagne verlassen',
  'members.leaveConfirm': 'Kampagne „{name}“ wirklich verlassen? Für einen erneuten Beitritt brauchst du einen neuen Einladungslink.',
  'members.you': '(du)',
  'invites.title': 'Einladungslinks',
  'invites.intro': 'Der Link wird nur einmal angezeigt. Wer ihn öffnet, legt ein Konto an (oder meldet sich an) und tritt der Kampagne bei.',
  'invites.none': 'Keine offenen Einladungen.',
  'invites.create': 'Link erstellen',
  'invites.label': 'Notiz (z. B. „für Anna“)',
  'invites.uses': 'Verwendungen',
  'invites.once': 'einmal',
  'invites.unlimited': 'beliebig oft',
  'invites.expires': 'Gültig',
  'invites.days': '{n} Tage',
  'invites.until': 'bis {date}',
  'invites.used': '{uses}/{max} verwendet',
  'invites.usedUnlimited': '{uses}× verwendet',
  'invites.revoke': 'Widerrufen',
  'invites.newLink': 'Neuer Einladungslink – jetzt kopieren, er wird nicht wieder angezeigt:',

  'account.title': 'Konto',
  'account.loggedInAs': 'Angemeldet als {name}',
  'account.password': 'Passwort ändern',
  'account.current': 'Aktuelles Passwort',
  'account.new': 'Neues Passwort',
  'account.repeat': 'Neues Passwort wiederholen',
  'account.mismatch': 'Die Passwörter stimmen nicht überein',
  'account.changed': 'Passwort geändert. Andere Geräte wurden abgemeldet.',
  'account.users': 'Benutzer (Admin)',
  'account.admin': 'Admin',
  'account.campaigns': 'Kampagnen',
  'account.resetPassword': 'Passwort setzen',
  'account.resetPrompt': 'Neues Passwort für {name} (mind. 10 Zeichen):',
  'account.resetDone': 'Passwort für {name} gesetzt; {name} wurde überall abgemeldet.',
  'account.deleteConfirm': 'Benutzer {name} endgültig löschen?',

  'campaigns.title': 'Kampagnen',
  'campaigns.new': 'Neue Kampagne',
  'campaigns.empty': 'Noch keine Kampagnen. Lege eine an oder importiere einen Obsidian-Vault.',
  'campaigns.notes': '{n} Notizen',
  'campaigns.ruleset': 'Regelwerk',
  'campaigns.import': 'Obsidian-Vault importieren',
  'campaigns.switch': 'Kampagne wechseln',
  'campaigns.settings': 'Einstellungen',
  'campaigns.export': 'Als Vault exportieren (ZIP)',
  'campaigns.deleteConfirm': 'Kampagne „{name}“ mit allen Notizen endgültig löschen?',

  'ruleset.5e-2014': 'D&D 5e (2014)',
  'ruleset.5e-2024': 'D&D 5e (2024)',
  'ruleset.mixed': 'Gemischt',

  'nav.search': 'Suche',
  'nav.graph': 'Graph',
  'nav.openLinks': 'Offene Links',
  'nav.quick': 'Schnellsprung',
  'nav.newNote': 'Neue Notiz',
  'nav.allTypes': 'Alle Typen',
  'nav.filterType': 'Nach Typ filtern',
  'nav.root': 'Wurzel',

  'quick.placeholder': 'Notiz suchen … (Enter öffnet, Strg+Enter legt an)',
  'quick.create': 'Neue Notiz „{title}“ anlegen',
  'quick.fulltext': 'Volltextsuche nach „{q}“',

  'note.title': 'Titel',
  'note.folder': 'Ordner',
  'note.type': 'Typ',
  'note.visibility': 'Sichtbarkeit',
  'note.properties': 'Eigenschaften',
  'note.addProperty': 'Eigenschaft hinzufügen',
  'note.propertyKey': 'Schlüssel',
  'note.backlinks': 'Verlinkt von',
  'note.mentions': 'Nur erwähnt (ohne Link)',
  'note.viaProperty': 'Verknüpft über dieses Feld',
  'note.noBacklinks': 'Keine Verweise auf diese Notiz.',
  'note.deleteConfirm': 'Notiz „{title}“ löschen? Links darauf bleiben als offene Links erhalten.',
  'note.unresolved': 'Offener Link – klicken zum Anlegen',
  'note.embedLoop': 'Einbettung übersprungen (Schleife)',
  'note.notFound': 'Notiz nicht gefunden.',
  'note.stale': 'Die Notiz wurde inzwischen geändert. Bitte neu laden.',
  'note.unsaved': 'Ungespeicherte Änderungen',
  'note.renameHint': 'Links in anderen Notizen werden automatisch angepasst.',
  'note.secretLabel': 'Nur DM',
  'note.commentLabel': 'DM-Kommentar',
  'note.empty': 'Diese Notiz ist leer.',
  'note.createTitle': 'Neue Notiz',

  'visibility.dm': 'Nur DM',
  'visibility.all': 'Alle Spieler',
  'visibility.players': 'Bestimmte Spieler',
  'visibility.private': 'Nur ich (und DM)',

  'search.title': 'Volltextsuche',
  'search.placeholder': 'Titel und Inhalt durchsuchen …',
  'search.none': 'Keine Treffer.',

  'graph.title': 'Graph',
  'graph.showUnresolved': 'Offene Links anzeigen',
  'graph.fit': 'Einpassen',

  'openLinks.title': 'Offene Links',
  'openLinks.none': 'Alle Links sind aufgelöst.',
  'openLinks.create': 'Anlegen',
  'openLinks.from': 'aus',

  'import.title': 'Obsidian-Import',
  'import.intro': 'Vault als ZIP hochladen (der Ordner .obsidian darf enthalten sein). Erneuter Import desselben Vaults aktualisiert vorhandene Notizen.',
  'import.choose': 'ZIP-Datei wählen',
  'import.analyzing': 'Analysiere Vault …',
  'import.preview': 'Vorschau',
  'import.vault': 'Vault',
  'import.homeNote': 'Startseite',
  'import.folder': 'Ordner',
  'import.notes': 'Notizen',
  'import.files': 'Dateien',
  'import.target': 'Ziel',
  'import.newCampaign': 'Neue Kampagne',
  'import.existingCampaign': 'Bestehende Kampagne',
  'import.start': 'Importieren',
  'import.running': 'Importiere …',
  'import.report': 'Prüfbericht',
  'import.created': 'neu',
  'import.updated': 'aktualisiert',
  'import.unchanged': 'unverändert',
  'import.links': 'Links',
  'import.resolved': 'aufgelöst',
  'import.openLinks': 'Offene Links',
  'import.conflicts': 'Namenskonflikte',
  'import.chosen': 'gewählt',
  'import.skipped': 'Übersprungene Dateien',
  'import.notInVault': 'In der Kampagne, aber nicht (mehr) im Vault',
  'import.warnings': 'Hinweise',
  'import.open': 'Kampagne öffnen',

  'field.goldUnit': 'GM',
  'field.pick': '{types} wählen …',
  'field.pickAny': 'Notiz wählen …',

  'statblock.title': 'Statblock',
  'statblock.create': 'Statblock anlegen (Gemeiner Bürger)',
  'statblock.none': 'Noch kein Statblock.',
  'statblock.load': '.monster laden',
  'statblock.download': '.monster speichern',
  'statblock.reset': 'Auf Bürger zurücksetzen',
  'statblock.resetConfirm': 'Statblock auf die Werte eines Gemeinen Bürgers zurücksetzen?',
  'statblock.remove': 'Entfernen',
  'statblock.removeConfirm': 'Statblock dieser Notiz entfernen?',
  'statblock.invalidFile': 'Die Datei ist keine gültige .monster-Datei (JSON).',
  'statblock.format': 'Darstellung',
  'statblock.general': 'Allgemein',
  'statblock.size': 'Größe',
  'statblock.type': 'Kreaturentyp',
  'statblock.tag': 'Zusatz',
  'statblock.alignment': 'Gesinnung',
  'statblock.defense': 'Rüstung und Trefferpunkte',
  'statblock.naturalBonus': 'Bonus nat. Rüstung',
  'statblock.armorText': 'RK-Text',
  'statblock.hitDice': 'Trefferwürfel (Anzahl)',
  'statblock.customHp': 'TP frei eingeben',
  'statblock.walk': 'Gehen',
  'statblock.abilities': 'Attribute und Rettungswürfe',
  'statblock.proficient': 'geübt',
  'statblock.expertise': 'Expertise',
  'statblock.damage': 'Schaden und Zustände',
  'statblock.vulnerable': 'anfällig',
  'statblock.resistant': 'resistent',
  'statblock.immune': 'immun',
  'statblock.special': 'Sonderfälle',
  'statblock.specialHint': 'mit ; trennen, z. B. Wucht, Stich und Hieb durch nichtmagische Angriffe',
  'statblock.speaks': 'Spricht',
  'statblock.understandsOnly': 'Versteht nur',
  'statblock.noCr': 'ohne (z. B. Spielercharakter)',
  'statblock.customCr': 'eigener Wert …',
  'statblock.profBonus': 'Übungsbonus',
  'statblock.crText': 'HG-Text',
  'statblock.addEntry': 'Eintrag',
  'statblock.up': 'nach oben',
  'statblock.down': 'nach unten',
  'statblock.descHint': 'Beschreibung (Markdown, _kursiv_, [[Links]])',
  'statblock.legendaryIntro': 'Einleitungstext der legendären Aktionen',

  'hierarchy.children': 'Enthält',
  'hierarchy.places': 'Orte',
  'hierarchy.placesIntro': 'Orte und alles mit dem Feld „Liegt in“ als Baum.',
  'hierarchy.empty': 'Noch keine Orte angelegt.',
  'hierarchy.unassigned': 'ohne übergeordneten Ort',

  'combat.title': 'Kampf',
  'combat.new': 'Neuer Kampf',
  'combat.defaultName': 'Kampf',
  'combat.none': 'Noch keine Kämpfe.',
  'combat.notFound': 'Kampf nicht gefunden.',
  'combat.sessionNote': 'Session-Notiz',
  'combat.roundN': 'Runde {n}',
  'combat.round': 'Runde',
  'combat.participants': '{n} Teilnehmer',
  'combat.status.prep': 'Vorbereitung',
  'combat.status.active': 'läuft',
  'combat.status.ended': 'beendet',
  'combat.kind.pc': 'SC',
  'combat.kind.npc': 'NSC',
  'combat.kind.monster': 'Monster',
  'combat.kind.other': 'Sonstiges',
  'combat.start': 'Kampf starten',
  'combat.next': 'Nächster Zug',
  'combat.prev': 'Zurück',
  'combat.end': 'Kampf beenden',
  'combat.endConfirm': 'Kampf beenden? Eine Zusammenfassung wird an die Session-Notiz angehängt.',
  'combat.deleteConfirm': 'Diesen Kampf endgültig löschen?',
  'combat.initiative': 'Initiative',
  'combat.initHint': 'Gesamtwert eintippen oder „w12“ für W20-Wurf + Bonus ({bonus}). Enter springt weiter.',
  'combat.hpInput': 'Schaden (7), Heilung (+5), temporäre TP (t8), setzen (=20)',
  'combat.hpInvalid': 'Eingabe nicht erkannt. Beispiele: 7, -7, +5, t8, =20',
  'combat.concentration': 'Konzentration',
  'combat.defeated': 'Besiegt',
  'combat.dead': 'Verstorben',
  'combat.undoDead': 'Doch nicht verstorben',
  'combat.deadConfirm': '„{name}“ als verstorben markieren?',
  'combat.remove': 'Entfernen',
  'combat.removeConfirm': '„{name}“ aus dem Kampf entfernen?',
  'combat.addCondition': 'Zustand hinzufügen',
  'combat.removeCondition': 'Klicken zum Entfernen',
  'combat.conditionCustom': 'eigener Zustand …',
  'combat.rounds': 'Runden',
  'combat.add': 'Hinzufügen',
  'combat.addPlaceholder': 'Monster, NSC oder Charakter … (oder freier Name)',
  'combat.addCharacters': 'Alle Charaktere',
  'combat.empty': 'Noch keine Teilnehmer.',
  'combat.noStatblock': 'Kein Statblock verknüpft.',
  'combat.log': 'Protokoll',
  'combat.help': 'Tastatur: N = nächster Zug, Umschalt+N = zurück. Initiative: Enter springt zur nächsten Zeile.',

  'quests.title': 'Quests',
  'quests.none': 'Noch keine Quests. Lege eine Notiz vom Typ „Quest“ an.',
  'quests.noStatus': 'ohne Status',
  'quests.new': 'Neue Quest',
  'quests.giver': 'Auftraggeber',
  'quests.location': 'Ort',
  'quests.reward': 'Belohnung',
  'quests.moveLeft': 'Status zurück',
  'quests.moveRight': 'Status weiter',

  'session.title': 'Session',
  'session.current': 'Aktuelle Session',
  'session.none': 'keine Session',
  'session.new': 'Neue Session',
  'session.openNote': 'Notiz öffnen',
  'session.createFirst': 'Lege die erste Session an.',
  'session.quickLog': 'Schnellnotiz',
  'session.quickLogHint': 'Was ist passiert? Enter speichert mit Uhrzeit ins Log. [[Links]] gehen.',
  'session.add': 'Eintragen',
  'session.log': 'Log',
  'session.logEmpty': 'Noch keine Einträge.',
  'session.dice': 'Würfelergebnis',
  'session.who': 'Wer?',
  'session.someone': 'Jemand',
  'session.rollLabel': 'Wofür? (z. B. Wahrnehmung)',
  'session.result': 'Ergebnis',
  'session.roll.check': 'Probe',
  'session.roll.save': 'Rettungswurf',
  'session.roll.attack': 'Angriff',
  'session.roll.damage': 'Schaden',
  'session.roll.initiative': 'Initiative',
  'session.roll.other': 'Wurf',
  'session.party': 'Gruppe',
  'session.noParty': 'Noch keine Charaktere (Typ „Charakter“).',
  'session.pp': 'PW',
  'session.init': 'Ini',
  'session.activeQuests': 'Aktive Quests',
  'session.noQuests': 'Keine aktiven Quests.',

  'sheet.title': 'Charakterbogen',
  'sheet.level': 'Stufe',
  'sheet.player': 'Spieler',
  'sheet.prof': 'Übungsbonus',
  'sheet.hitDice': 'Trefferwürfel',
  'sheet.hitDie': 'Trefferwürfel',
  'sheet.spendHitDie': 'Trefferwürfel ausgeben',
  'sheet.regainHitDie': 'Trefferwürfel zurück',
  'sheet.deathSaves': 'Todesrettungswürfe',
  'sheet.deathSuccess': 'Erfolg',
  'sheet.deathFailure': 'Fehlschlag',
  'sheet.inspiration': 'Inspiration',
  'sheet.heroicInspiration': 'Heldenhafte Inspiration',
  'sheet.longRest': 'Lange Rast',
  'sheet.longRestHint': 'TP voll, Zauberplätze zurück, halbe Trefferwürfel zurück',
  'sheet.longRestConfirm': 'Lange Rast: TP auffüllen, Zauberplätze und die Hälfte der Trefferwürfel zurücksetzen?',
  'sheet.passivePerception': 'Passive Wahrnehmung',
  'sheet.passiveInsight': 'Passives Motiv erkennen',
  'sheet.passiveInvestigation': 'Passive Nachforschungen',
  'sheet.attacks': 'Angriffe und Aktionen',
  'sheet.features': 'Merkmale und Fähigkeiten',
  'sheet.weaponMasteries': 'Waffenbeherrschung',
  'sheet.weaponMasteriesHint': 'mit Komma trennen, z. B. Langschwert: Plagen, Kurzbogen: Verlangsamen',
  'sheet.spellcasting': 'Zauberwirken',
  'sheet.spellAbility': 'Zauberattribut',
  'sheet.noSpellcasting': 'kein Zauberwirken',
  'sheet.spellDc': 'Zauber-SG',
  'sheet.spellAttack': 'Zauberangriff',
  'sheet.slotLevel': 'Grad {n}',
  'sheet.slotsUsed': 'Zauberplatz verbraucht',
  'sheet.slotsTotal': 'Zauberplätze (gesamt)',
  'sheet.proficiencies': 'Übung und Sprachen',
  'sheet.proficienciesHint': 'Rüstungen, Waffen, Werkzeuge … (Markdown)',
  'sheet.equipment': 'Ausrüstung',
  'sheet.deadLocked': 'Verstorben – Spielwerte sind gesperrt, nur Inventar, Münzen und Ausrüstung lassen sich ändern.',
  'map.noImage': 'Diese Karte hat noch kein Bild.',
  'map.pickImage': 'Bild wählen …',
  'map.upload': 'Bild hochladen',
  'map.select': 'Auswählen',
  'map.addPin': 'Pin setzen',
  'map.addPinHint': 'Auf die Karte klicken, um einen Pin zu setzen (Esc beendet).',
  'map.grid': 'Raster',
  'map.showToPlayers': 'Spielern zeigen',
  'map.shownToPlayers': 'Wird gezeigt – Ausschnitt senden',
  'map.showToPlayersHint': 'Zeigt diese Karte mit dem aktuellen Ausschnitt in der Spieleransicht (TV, Remote).',
  'map.shownCopied': 'Spieleransicht aktualisiert – Link in die Zwischenablage kopiert.',
  'screen.title': 'Spieleransicht',
  'screen.intro': 'Ein geheimer Link für TV/Projektion und Remote-Spieler. Er zeigt nur die Karte, die du freigibst – ohne DM-Pins, verborgene Tokens, Gegner-TP und alles unter dem Nebel. Spielerkonten folgen später.',
  'screen.off': 'Noch nicht eingerichtet. In einer Karte „Spielern zeigen“ wählen oder hier anlegen.',
  'screen.create': 'Spieleransicht anlegen',
  'screen.link': 'Link',
  'screen.copy': 'Kopieren',
  'screen.copied': 'Kopiert',
  'screen.open': 'Öffnen',
  'screen.map': 'Gezeigte Karte',
  'screen.noMap': 'keine – Spieler sehen einen Wartebildschirm',
  'screen.clearMap': 'Karte ausblenden',
  'screen.rotate': 'Neuer Link',
  'screen.rotateConfirm': 'Neuen Link erzeugen? Der bisherige funktioniert danach nicht mehr.',
  'screen.disable': 'Abschalten',
  'screen.disableConfirm': 'Spieleransicht abschalten? Der Link funktioniert danach nicht mehr.',
  'screen.waiting': 'Warte auf den Spielleiter …',
  'screen.notFound': 'Diese Spieleransicht gibt es nicht (mehr). Bitte den Spielleiter nach dem aktuellen Link fragen.',
  'screen.fullscreen': 'Vollbild',
  'screen.fit': 'Ausschnitt des Spielleiters',
  'map.tokenImage': 'Bild',
  'map.tokenImageFromNote': 'Bild kommt aus der Notiz (Token-Bild).',
  'token.title': 'Token-Bild für {name}',
  'token.upload': 'Bild hochladen',
  'token.pickExisting': 'oder vorhandenes Bild wählen …',
  'token.hint': 'Bild hochladen oder wählen, dann den Kreis durch Ziehen und Zoomen ausrichten.',
  'token.zoom': 'Zoom',
  'token.apply': 'Übernehmen',
  'token.set': 'Token-Bild wählen …',
  'token.change': 'Token-Bild ändern …',
  'token.remove': 'Entfernen',
  'token.loadError': 'Bild konnte nicht geladen werden.',
  'map.measure': 'Messen',
  'map.measureHint': 'Lineal misst nur für dich (Esc entfernt es). Kegel, Kreis und Quadrat bleiben als Schablone liegen und sind auch in der Spieleransicht zu sehen – Größen in ganzen Feldern nach 5e.',
  'map.measureDragHint': 'Vom Ursprung aus ziehen (Esc beendet).',
  'map.ruler': 'Lineal',
  'map.cone': 'Kegel',
  'map.circle': 'Kreis',
  'map.square': 'Quadrat',
  'map.templatesInfo': '{n} Schablone(n) auf der Karte. Klick auf eine Schablone wählt sie aus.',
  'map.templateDelete': 'Schablone entfernen',
  'map.templatesClear': 'Alle Schablonen entfernen',
  'map.fog': 'Nebel',
  'map.fogEnabled': 'Nebel aktiv (Spieler sehen nur Aufgedecktes)',
  'map.fogHint': 'Ziehen auf der Karte deckt auf bzw. verdeckt. Du siehst den Nebel halbtransparent, Spieler deckend.',
  'map.fogRevealRect': 'Rechteck aufdecken',
  'map.fogRevealBrush': 'Pinsel aufdecken',
  'map.fogHideRect': 'Rechteck verdecken',
  'map.fogHideBrush': 'Pinsel verdecken',
  'map.fogBrush': 'Pinselgröße',
  'map.fogUndo': 'Rückgängig',
  'map.fogRevealAll': 'Alles aufdecken',
  'map.fogReset': 'Alles verdecken',
  'map.fogResetConfirm': 'Den ganzen Nebel zurücksetzen (alles verdeckt)?',
  'map.fogRevealHint': 'Ziehen, um aufzudecken (Esc beendet).',
  'map.fogHideHint': 'Ziehen, um zu verdecken (Esc beendet).',
  'map.addToken': 'Token setzen',
  'map.addTokenHint': 'Auf die Karte klicken, um einen Token zu setzen (Esc beendet).',
  'map.tokenName': 'Kreatur oder freier Name …',
  'map.tokenHp': 'TP',
  'map.tokenSize': 'Größe (Felder)',
  'map.tokenHidden': 'Für Spieler verborgen',
  'map.tokenDelete': 'Token entfernen',
  'map.tokenCombatHint': 'TP und Zustände im Kampf-Tracker ändern.',
  'combat.map': 'Kampfkarte',
  'combat.mapNone': 'Keine Karte',
  'combat.showMap': 'Karte',
  'map.fit': 'Einpassen',
  'map.fullscreen': 'Vollbild',
  'map.backToNote': 'Zur Notiz',
  'map.pinNote': 'Notiz (z. B. Raumnummer) …',
  'map.pinLabel': 'Beschriftung',
  'map.pinLabelHint': 'leer = aus der Notiz',
  'map.pinLink': 'Verknüpfte Notiz',
  'map.pinVisible': 'Für Spieler sichtbar',
  'map.pinDelete': 'Pin löschen',
  'map.openNote': 'Notiz öffnen',
  'map.noLink': 'Keine verknüpfte Notiz',
  'map.gridType': 'Art',
  'map.gridNone': 'Kein Raster',
  'map.gridSquare': 'Quadrate',
  'map.gridHex': 'Hexfelder',
  'map.gridSize': 'Feldgröße (px)',
  'map.gridOffsetX': 'Versatz X',
  'map.gridOffsetY': 'Versatz Y',
  'map.gridScale': 'Maßstab je Feld',
  'map.gridColor': 'Farbe',
  'map.gridOpacity': 'Deckkraft',
  'map.gridHint': 'Feldgröße so einstellen, dass das Raster auf der Karte liegt; mit dem Versatz verschieben.',
  'catalog.title': 'Kataloge',
  'catalog.intro': 'Ausrüstung, Waffen und Rüstungen dieser Kampagne – Vorschläge fürs Inventar. Felder direkt bearbeiten; Änderungen werden beim Verlassen des Felds gespeichert.',
  'catalog.filter': 'Filtern …',
  'catalog.count': '{n} Einträge',
  'catalog.import': 'CSV importieren',
  'catalog.export': 'CSV exportieren',
  'catalog.defaults': 'Grundbestand ergänzen',
  'catalog.defaultsHint': 'Fehlende Einträge aus dem Spielerhandbuch hinzufügen; vorhandene bleiben unverändert',
  'catalog.clear': 'Alle löschen',
  'catalog.clearConfirm': 'Alle {kind} dieser Kampagne löschen? Inventare der Charaktere bleiben unverändert.',
  'catalog.replaceConfirm': 'Alle {kind} durch den Inhalt der Datei ersetzen?',
  'catalog.importHint': 'Erste Zeile: Spaltennamen, z. B. {columns}. Trennzeichen ; oder , – Dezimalkomma ist in Ordnung. Englische Spaltennamen (name, price, weight, damage …) werden auch erkannt.',
  'catalog.modeMerge': 'Ergänzen (gleiche Namen aktualisieren)',
  'catalog.modeReplace': 'Ersetzen (Katalog vorher leeren)',
  'catalog.report': '{added} neu, {updated} aktualisiert, {removed} entfernt.',
  'catalog.newPlaceholder': 'Neuer Eintrag (Name) …',
  'catalog.add': 'Hinzufügen',
  'inventory.title': 'Inventar',
  'inventory.item': 'Gegenstand',
  'inventory.qty': 'Anz.',
  'inventory.value': 'Wert/Stk. (GM)',
  'inventory.weight': 'Gewicht/Stk. (kg)',
  'inventory.total': 'Summe',
  'inventory.add': 'Hinzufügen',
  'inventory.remove': 'Entfernen',
  'inventory.addPlaceholder': 'Neuer Gegenstand … (Vorschläge beim Tippen)',
  'sheet.equipmentHint': 'Ausrüstung (Markdown, [[Gegenstände]] verlinkbar)',
  'sheet.coin.cp': 'KM',
  'sheet.coin.sp': 'SM',
  'sheet.coin.ep': 'EM',
  'sheet.coin.gp': 'GM',
  'sheet.coin.pp': 'PM',

  'polls.title': 'Termine',
  'polls.intro': 'Terminumfragen für die Runde. Jede Person bekommt einen eigenen Link und antwortet ohne Konto; der festgelegte Termin wird zur Session-Notiz.',
  'polls.playerIntro': 'Umfragen, an denen du teilnimmst. Tippe auf einen Termin, um zwischen Ja, Vielleicht und Nein zu wechseln.',
  'polls.none': 'Noch keine Umfragen.',
  'polls.new': 'Neue Umfrage',
  'polls.create': 'Umfrage anlegen',
  'polls.name': 'Titel',
  'polls.defaultTitle': 'Nächste Sitzung',
  'polls.description': 'Beschreibung',
  'polls.location': 'Ort',
  'polls.deadline': 'Antworten bis',
  'polls.noDeadline': 'ohne Frist',
  'polls.minYes': 'Mindestens Zusagen',
  'polls.minYesHint': 'inkl. DM',
  'polls.maybeCounts': '„Vielleicht“ zählt fürs Quorum mit',
  'polls.linkDays': 'Links gültig nach dem Termin (Tage)',
  'polls.slots': 'Terminvorschläge',
  'polls.dates': 'Tage',
  'polls.addDate': 'Tag hinzufügen',
  'polls.startTime': 'Beginn',
  'polls.endTime': 'Ende (optional)',
  'polls.slotsHint': 'Mehrere Tage wählen – alle bekommen dieselbe Uhrzeit. Zeiten gelten in deutscher Zeit (Europe/Berlin).',
  'polls.minSlots': 'Mindestens zwei Terminvorschläge',
  'polls.participants': 'Teilnehmer',
  'polls.includeMe': 'Mich als Pflichtteilnehmer aufnehmen',
  'polls.members': 'Mitglieder der Kampagne',
  'polls.guests': 'Weitere Personen (ohne Konto), eine pro Zeile',
  'polls.required': 'Pflicht',
  'polls.requiredHint': 'Sagt eine Pflichtperson Nein, ist der Termin raus.',
  'polls.answered': '{n} von {total} geantwortet',
  'polls.slotCount': '{n} Termine',
  'polls.status.open': 'offen',
  'polls.status.closed': 'geschlossen',
  'polls.status.fixed': 'festgelegt',
  'polls.status.cancelled': 'abgebrochen',
  'polls.until': 'bis {date}',
  'polls.answer.yes': 'Ja',
  'polls.answer.maybe': 'Vielleicht',
  'polls.answer.no': 'Nein',
  'polls.answer.none': 'Offen',
  'polls.sum': 'Summe',
  'polls.points': '{n} Punkte',
  'polls.quorum': 'Quorum erfüllt',
  'polls.blocked': 'Pflichtperson fehlt',
  'polls.best': 'Bester Termin',
  'polls.matrixHint': 'Klick in eine Zelle trägt eine Antwort für die Person ein (z. B. per Messenger erhalten).',
  'polls.finalize': 'Festlegen',
  'polls.finalizeConfirm': 'Termin {slot} festlegen? Die Umfrage wird abgeschlossen und eine Session-Notiz angelegt.',
  'polls.fixedOn': 'Festgelegt: {slot}',
  'polls.openSession': 'Zur Session-Notiz',
  'polls.ics': 'In den Kalender (.ics)',
  'polls.close': 'Schließen',
  'polls.reopen': 'Wieder öffnen',
  'polls.cancel': 'Abbrechen',
  'polls.cancelConfirm': 'Umfrage abbrechen? Die Links werden sofort ungültig.',
  'polls.delete': 'Löschen',
  'polls.deleteConfirm': 'Umfrage „{title}“ endgültig löschen?',
  'polls.settings': 'Einstellungen',
  'polls.addSlot': 'Termin hinzufügen',
  'polls.removeSlotConfirm': 'Termin {slot} entfernen? Die Antworten dazu gehen verloren.',
  'polls.addParticipant': 'Person hinzufügen',
  'polls.removeParticipantConfirm': '{name} entfernen? Die Antworten gehen verloren.',
  'polls.links': 'Persönliche Links',
  'polls.linksHint': 'Jeden Link nur an die jeweilige Person schicken (z. B. per WhatsApp/Signal). Damit lässt sich nur diese Umfrage beantworten.',
  'polls.copyLink': 'Link kopieren',
  'polls.copied': 'Kopiert',
  'polls.rotate': 'Neuer Link',
  'polls.rotateConfirm': 'Neuen Link für {name} erzeugen? Der bisherige funktioniert dann nicht mehr.',
  'polls.revoke': 'Widerrufen',
  'polls.revoked': 'widerrufen',
  'polls.account': 'Konto',
  'polls.myAnswer': 'Meine Antworten',
  'polls.comment': 'Kommentar (optional)',
  'polls.commentFor': 'Kommentar zu {slot}',
  'polls.closedNotice': 'Die Umfrage nimmt keine Antworten mehr an.',
  'polls.deadlineNotice': 'Antworten bis {date}',
  'polls.tapHint': 'Tippen wechselt Ja → Vielleicht → Nein.',
  'polls.othersSum': '{yes} Ja · {maybe} Vielleicht',
  'polls.hello': 'Hallo {name}!',
  'polls.invalid': 'Dieser Link ist ungültig oder abgelaufen. Bitte frag den DM nach einem neuen Link.',
  'polls.cancelledNotice': 'Diese Umfrage wurde abgebrochen.',
  'polls.savedHint': 'Antworten werden sofort gespeichert und lassen sich bis zum Ende der Umfrage ändern.',
  'polls.next': 'Nächste Sitzung',
  'polls.openCount': '{n} offene Umfrage(n)',
  'polls.back': 'Alle Umfragen',

  'settings.title': 'Einstellungen',
  'settings.types': 'Notiz-Typen',
  'settings.color': 'Farbe',
  'settings.label': 'Bezeichnung',
  'settings.danger': 'Gefahrenzone',
  'settings.deleteCampaign': 'Kampagne löschen',
} as const;

export type MessageKey = keyof typeof de;

export function t(key: MessageKey, params?: Record<string, string | number>): string {
  let s: string = de[key] ?? key;
  if (params) for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

/** Für dynamische Schlüssel (z. B. `ruleset.${x}`), mit Fallback. */
export function tDyn(key: string, fallback?: string): string {
  return (de as Record<string, string>)[key] ?? fallback ?? key;
}
